import { ECostType } from '#core/const/cost-type';

import { DEFAULT_FORM_AUTOFILL_VALUES } from '#route/campaigns/components/autofill/const';

import { EBType } from '../../types';

export const HARDCODE_CPM_MIN_REMOVE_LATER_ABSOLUTELY = 125;
export const HARDCODE_CPO_MIN_REMOVE_LATER_ABSOLUTELY = 50;
export const HARDCODE_CPC_MIN_REMOVE_LATER_ABSOLUTELY = 2;

export const DEFAULT_CPO_HOLD_PERCENT = 30;
export const CPO_STEP = 1;
export const DEFAULT_CPO_BUDGET_MULTIPLIER = 10;
export const DEFAULT_MIN_BUDGET = 1000;

export const DEFAULT_VALUES = {
    active: {
        booster : true,
        carousel: true
    },
    category: undefined,
    sum     : undefined,
    minCPM  : 0,
    minCPO  : 0,
    minCPC  : 0,
    btype   : EBType.BALANCE,
    costType: ECostType.CPM,
    ...DEFAULT_FORM_AUTOFILL_VALUES
};
